<template>
  <div class="flex flex-wrap col-12 border-box white-bg body-padding-desktop">
    <GenerateForm
      :data="participantEmergencyContact"
      :form-type="typeOfForm"
    />
  </div>
</template>

<script>
import GenerateForm from '@/components/form/GenerateForm.vue';

export default {
  components: { GenerateForm },
  data () {
    return { typeOfForm: 'emergencyContact' };
  },
  computed: {
    cartItem () {
      return this.$store.state.cartItem;
    },
    participantEmergencyContact () {
      if (this.cartItem.participants[0]) {
        return this.cartItem.participants[0].emergency_contacts && this.cartItem.participants[0].emergency_contacts.length ? this.cartItem.participants[0].emergency_contacts[0] : {};
      }
      return {};
    }
  },
  mounted () {
    this.$store.commit('setSubscriptionHeader', { title: 'Contact d\'urgence', subtitle: 'Ajoutez/modifiez les coordonnées du contact d\'urgence pour la personne qui utilisera l\'abonnement.' });
  }
};
</script>
